import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_auth/provider/$patientId/')({
  beforeLoad: ({ params }) => {
    throw redirect({ to: '/care-plan/$patientId', params: { patientId: params.patientId } });
  },
});
